
import { helpers } from 'vuelidate/lib/validators'

export const phoneValidator = (value) => {
  const regex = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/g
  const result = regex.test(value)
  return !helpers.req(value) || result
}
